import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import config from '../config';

export const fetchTerminals = createAsyncThunk('terminals/fetch', async () => {
  const res = await fetch(`${config.API_URL}api/terminal`, { credentials: 'include' });
  if (!res.ok) throw new Error(`Failed to fetch terminals: ${res.status}`);
  return await res.json();
});

const terminalsSlice = createSlice({
  name: 'terminals',
  initialState: {
    list: [],
    loading: false,
    error: null
  },
  reducers: {
    terminalUpserted: (state, action) => {
      const t = action.payload;
      const i = state.list.findIndex(x => x.id === t.id);
      // console.log('Terminal upserted:', t, i);
      if (i >= 0) state.list[i] = { ...state.list[i], ...t };
      else state.list.push(t);
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTerminals.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchTerminals.fulfilled, (state, action) => {
        state.list = action.payload;
        state.loading = false;
      })
      .addCase(fetchTerminals.rejected, (state, action) => {
        state.error = action.error.message;
        state.loading = false;
      });
  }
});

export const { terminalUpserted } = terminalsSlice.actions;
export default terminalsSlice.reducer;